import { Component, Input, OnInit } from '@angular/core';

export interface LoadPanelOption{
  visible:boolean;
  message:string;
  closeOnOutsideClick:boolean;
  showPane?:boolean;
  ofPosition?:string;
  shadingColor?:string;
}

@Component({
  selector: 'app-load-panel',
  templateUrl: './load-panel.component.html',
  styleUrls: ['./load-panel.component.less']
})
export class LoadPanelComponent implements OnInit {

  constructor() { }

  @Input() option:LoadPanelOption={
    visible:false,
    message:"",
    closeOnOutsideClick:false,
  };

  ngOnInit(): void {
  }

}
